import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class DataService {
    userName: string;
    private dataObj = {};
    objnew = [];
    setData(key, value, concat?) {
        if(concat && this.dataObj[key]) {
            Object.assign(this.dataObj[key], value)
        } else {
            this.dataObj[key] = value;
        }
    }
    getData(key) {
        return this.dataObj[key];
    }

    getSubscribeData(key): Observable<any> {
        return new Observable(observer => {
            observer.next(this.dataObj[key]);
        });
    }

  
}